import React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CircularProgress from '@mui/material/CircularProgress';
import CircleIcon from '@mui/icons-material/FiberManualRecord';
import RadioUnChk from '@mui/icons-material/RadioButtonUnchecked';
import {
  Grid,
  Button,
  IconButton,
  Typography,
  FormControl,
  OutlinedInput,
  InputAdornment,
  FormControlLabel,
  Switch,
  Menu,
  Tooltip,
  MenuItem
} from '@mui/material';
import useAlertSideBarHook from './useAlertSideBarHook';
import './styles.scss';

export default function AlertSideBar({ alertSideBarOpen, setAlertSideBarOpen, setQtdIconeNotificacao }) {
  const {
    toggleDrawer,
    searchTerm,
    setSearchTerm,
    markAsRead,
    limitaTamanhoTexto,
    showOnlyUnread,
    setShowOnlyUnread,
    displayNotifications,
    formataDataHora,
    loadReadMsg,
    markAllAsRead,
    openMenu,
    anchorEl,
    handleMenuOpen,
    handleMenuClose
  } = useAlertSideBarHook({ setAlertSideBarOpen, setQtdIconeNotificacao });

  return (
    <Drawer
      className="alert-sidebar"
      open={alertSideBarOpen}
      onClose={toggleDrawer(false)}
      anchor="right"
    >
      <Box role="presentation">
        <Box className="alert-sidebar-header">
          <Grid container className="header-sidebar-container">
            <Grid item xs={10}>
              <Box className="texto-header texto-negrito">Notificações</Box>
            </Grid>
            <Grid item xs={2}>
              <Box>
                <Button className="btn-close" onClick={toggleDrawer(false)}>
                  <ClearIcon />
                </Button>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <FormControl variant="outlined" className="input-pesquisa-notificacao">
                <OutlinedInput
                  type="text"
                  placeholder="Pesquisar..."
                  autoFocus
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton edge="end">
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </Grid>

            <Grid item xs={11} className="filtro-nao-lidas">
              <FormControlLabel
                control={
                  <Switch
                    checked={showOnlyUnread}
                    onChange={() => setShowOnlyUnread(prev => !prev)}
                    size="small"
                  />
                }
                labelPlacement="start"
                label="Somente não lidas"
              />
            </Grid>

            <Grid item xs={1} className="demais-opcoes" justifyContent="flex-end">
              <IconButton size="small" onClick={handleMenuOpen}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                className="demais-opcoes-menu"
              >
                <MenuItem
                  onClick={() => {
                    markAllAsRead();
                    handleMenuClose();
                  }}
                >
                  Marcar todas como lidas
                </MenuItem>
              </Menu>
            </Grid>

            <Grid item xs={12}>
              <Box className="box-notificacao">
                <List>
                  {displayNotifications.map((item, index) => (
                    <Box key={item.id}>
                      <ListItem className="item-notificacao">
                        <Tooltip
                          title={item.read === 'S' ? 'Marcar como não lida' : 'Marcar como lida'}
                          placement="bottom"
                        >
                          <span>
                            {loadReadMsg && loadReadMsg === item.id && (
                              <CircularProgress className="icone-notificacao-loading" />
                            )}

                            {loadReadMsg !== item.id && (
                              <IconButton size="small" onClick={() => markAsRead(item.id, item.read)}>
                                {item.read === 'S' && <RadioUnChk className="icone-notificacao-read" />}

                                {item.read === 'N' && <CircleIcon className="icone-notificacao" />}
                              </IconButton>
                            )}
                          </span>
                        </Tooltip>
                        <Box className={`${item.read === 'S' ? 'opacity' : ''}`}>
                          <Typography variant="body2" fontWeight="bold" className="texto margin-left-10">
                            {item.title}
                          </Typography>
                          {item.nomeCliente && (
                            <Typography
                              className="texto margin-left-10"
                              variant="body2"
                              fontWeight="gray"
                            >
                              Cliente: {limitaTamanhoTexto(item.nomeCliente, 23)}
                            </Typography>
                          )}
                          <Typography className="texto margin-left-10" variant="body2" fontWeight="gray">
                            {limitaTamanhoTexto(item.body)}
                          </Typography>
                          <Typography className="margin-left-10" variant="caption" color="gray">
                            {formataDataHora(item.createdAt)}
                          </Typography>
                        </Box>
                      </ListItem>
                      {index < displayNotifications.length - 1 && <Divider />}
                    </Box>
                  ))}
                </List>

                {displayNotifications.length <= 0 && (
                  <Box className="box-sem-notificacao texto-centro margin-top-10">
                    <Typography>😊 Sem notificações...</Typography>
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Drawer>
  );
}
